import _slicedToArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from 'react';
import { useCountDown } from 'ahooks';
import { useDesignContext } from '../../design-provider';
import { classNames } from '../utils/classnames';
import ICON_SALE_BOLT from '../images/icon-sale-bolt.png';
import { getImageSrc } from '../utils/get-image-src';
export var GoodsCardSale = function GoodsCardSale(props) {
  var _useDesignContext = useDesignContext(),
    local = _useDesignContext.local;
  var _useCountDown = useCountDown(props),
    _useCountDown2 = _slicedToArray(_useCountDown, 2),
    _useCountDown2$ = _useCountDown2[1],
    days = _useCountDown2$.days,
    hours = _useCountDown2$.hours,
    minutes = _useCountDown2$.minutes,
    seconds = _useCountDown2$.seconds;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    initialRenderComplete = _React$useState2[0],
    setInitialRenderComplete = _React$useState2[1];
  useEffect(function () {
    setInitialRenderComplete(true);
  }, []);
  function pad(value) {
    return String(value).padStart(2, '0');
  }
  return !initialRenderComplete ? _jsx(_Fragment, {}) : _jsxs("div", Object.assign({
    className: 'mt-2 flex items-center'
  }, {
    children: [_jsx("img", {
      className: classNames('w-3.5 h-3.5', 'cq-pc:w-5 cq-pc:h-5'),
      src: getImageSrc(ICON_SALE_BOLT)
    }), _jsxs("span", Object.assign({
      className: classNames('text-2xs text-[#583E45] bg-gradient-to-r from-transparent to-[#FEF9ED] p-1', 'cq-pc:text-xs')
    }, {
      children: [local.sale.saleText, " ", days > 0 && "".concat(days).concat(local.sale.dayText), pad(hours), ":", pad(minutes), ":", pad(seconds)]
    }))]
  }));
};